<script>
import {
  ArrowUpIcon,
  ChevronRightIcon,
  UserIcon,
  MailIcon,
  MessageCircleIcon,
  PlayIcon,
  VideoIcon,
} from "vue-feather-icons";
import { Carousel, Slide } from "vue-carousel";

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

import Footer from "@/components/footer";
import Features from "@/components/features";

// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

const axios = require("axios").default;

/**
 * Index-hotel component
 */
export default {
  data() {
    return {
      isCondensed: false,
      slide: 0,
      date: new Date(),
      checkoutdate: new Date(Date.now() + 3600 * 1000 * 24),
      featuresData: [
        {
          icon: "uil uil-wifi",
          title: "Free WIFI",
          description: "High Speed WIFI on your whole stay with us",
        },
        {
          icon: "uil uil-vector-square",
          title: "Full Board Meals",
          description: "3 meals per day included in our package",
        },
        {
          icon: "uil uil-file-search-alt",
          title: "Shuttle Service",
          description:
            "We can arrange shuttle service for your departure and/or arrival",
        },
      ],
      hotelsMin: {},
      hotels: {},
      isLoading: true,
      fullPage: true,
    };
  },
  components: {
    Footer,
    Carousel,
    Slide,
    ArrowUpIcon,
    ChevronRightIcon,
    UserIcon,
    MailIcon,
    VideoIcon,
    MessageCircleIcon,
    PlayIcon,
    flatPickr,
    Features,
    Loading,
  },
  created: function() {
    this.getHotels();
  },
  methods: {
    toggleMenu() {
      this.isCondensed = !this.isCondensed;
      if (this.isCondensed) {
        document.getElementById("navigation").style.display = "block";
      } else document.getElementById("navigation").style.display = "none";
    },
    getHotels() {
      let self = this;
      axios
        .get("https://app.quarantinefacility.ph/api/get_hotel")
        .then(function(response) {
          for (let x = 0; x < 3; x++) {
            self.hotelsMin[x] = response.data[x];
            setTimeout(() => {
              self.isLoading = false;
            }, 1000);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
  },
};
</script>

<template>
  <div>
    <header
      id="topnav"
      class="defaultscroll sticky"
      style="background-color: white;"
    >
      <div class="container">
        <!-- Logo container-->
        <div>
          <router-link to="/" class="logo"
            ><img src="images/quarantine_black.png" height="50" alt=""
          /></router-link>
        </div>
        <div class="buy-button">
          <router-link to="/booking" class="btn btn-primary"
            >Book Now</router-link
          >
        </div>
        <!--end login button-->
        <!-- End Logo container-->
        <div class="menu-extras">
          <div class="menu-item">
            <!-- Mobile menu toggle-->
            <a
              class="navbar-toggle"
              @click="toggleMenu()"
              :class="{ open: isCondensed === true }"
            >
              <div class="lines">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </a>
            <!-- End mobile menu toggle-->
          </div>
        </div>

        <div id="navigation">
          <!-- Navigation Menu-->
          <ul
            class="navigation-menu"
            v-scroll-spy-active="{ selector: 'li.has-submenu' }"
          >
            <li class="has-submenu">
              <a href="javascript: void(0);" v-scroll-to="'#home'">Home</a>
            </li>
            <li class="has-submenu">
              <a href="javascript: void(0);" v-scroll-to="'#rooms'">Rooms</a>
            </li>
            <li class="has-submenu">
              <a href="javascript: void(0);" v-scroll-to="'#services'"
                >Services</a
              >
            </li>
            <li class="has-submenu">
              <a href="javascript: void(0);" v-scroll-to="'#contact'"
                >Contact</a
              >
            </li>
          </ul>
          <!--end navigation menu-->
        </div>
        <!--end navigation-->
      </div>
      <!--end container-->
    </header>

    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="fullPage"
    ></loading>

    <!-- Hero Start -->
    <section class="main-slider" id="home">
      <b-carousel fade id="carousel-1" v-model="slide" class="slides">
        <b-carousel-slide
          class="bg-slider bg-animation-left d-flex align-items-center"
          :style="{
            'background-image':
              'url(' +
              'https://imagevars.gulfnews.com/2021/01/17/Inside-hotel-quarantine-in-Manila_177104e3f25_original-ratio.JPG' +
              ')',
          }"
        >
          <div class="container">
            <div class="row text-left text-dark">
              <div class="col-lg-7 col-md-7">
                <div
                  class="title-heading position-relative mt-4"
                  style="z-index: 1"
                >
                  <h1 class="heading mb-3">
                    Quarantine Facility Online Booking
                  </h1>
                  <p class="para-desc">
                    Hassle-free booking
                  </p>
                  <div class="watch-video mt-4 pt-2">
                    <router-link to="/booking" class="btn btn-primary"
                      >Book now</router-link
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-carousel-slide>
        <b-carousel-slide
          class="bg-slider bg-animation-left d-flex align-items-center"
          :style="{
            'background-image':
              'url(' +
              'https://images.summitmedia-digital.com/esquiremagph/images/2020/04/13/DOH-Hotel-Rooms-Quarantine-Facilities-MAIN-IMAGE.jpg' +
              ')',
          }"
        >
          <div class="container">
            <div class="row text-left text-dark">
              <div class="col-lg-7 col-md-7">
                <div
                  class="title-heading position-relative mt-4"
                  style="z-index: 1"
                >
                  <h1 class="heading mb-3">
                    QuarantineFacility.ph, your quarantine facility booking
                    portal
                  </h1>
                  <p class="para-desc">
                    Book your quarantine with us.
                  </p>
                  <div class="watch-video mt-4 pt-2">
                    <router-link to="/booking" class="btn btn-primary"
                      >Book now</router-link
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-carousel-slide>
      </b-carousel>
    </section>
    <!--end section-->
    <!-- Hero End -->

    <!--end section-->
    <!-- Partners End -->

    <!-- Rooms Start -->
    <section class="section" id="rooms">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 text-center">
            <div class="section-title mb-4 pb-2">
              <h4 class="title mb-4">Our Partner Accredited Facilities</h4>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
        <div class="row">
          <div
            v-for="(hotel, index) in this.hotelsMin"
            :key="index"
            class="col-lg-4 col-md-6 mt-4 pt-2"
          >
            <div
              class="card work-container work-modern rounded border-0 overflow-hidden"
            >
              <div class="card-body p-0">
                <img
                  :src="hotel.images[0]"
                  class="img-fluid rounded"
                  alt="work-image"
                />
                <div class="overlay-work"></div>
                <div class="content">
                  <a
                    href="https://quarantinefacility.ph/booking"
                    class="title text-white pb-2 border-bottom"
                    >{{ hotel.hotel_name }}</a
                  >
                  <div style="padding:10px"></div>
                  <p class="text-white d-block mb-0">
                    {{ hotel.city }} {{ hotel.region }}
                  </p>
                  <p class="text-dark d-block mb-0">
                    Rent: ₱<span class="text-success">{{ new Intl.NumberFormat('en-US').format(hotel.price)}}</span> /Night
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end row-->

        <div class="row justify-content-center">
          <div class="col-12 text-center mt-4 pt-2">
            <router-link
              to="/hotels"
              class="btn btn-primary"
              test-prop="asdasdad"
              >See More <i class="mdi mdi-chevron-right"></i
            ></router-link>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>
    <!--end section-->
    <!-- Rooms End -->

    <!-- CTA Start -->
    <section
      class="section bg-cta"
      style="background: url('https://www.pegs.com/wp-content/uploads/2020/03/hotel-room-with-bed.jpg') center center"
      id="feature"
    >
      <div class="bg-overlay"></div>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 text-center">
            <div class="section-title">
              <h4 class="title title-dark text-white mb-4">
                QuarantineFacility.ph
              </h4>
              <p class="text-light para-dark para-desc mx-auto">
                Hassle-free Quarantine Bookings
              </p>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>
    <!--end section-->
    <!-- CTA End -->

    <!-- Services Start -->
    <section class="section" id="services">
      <div class="container pb-lg-4 mb-md-5 mb-4">
        <div class="row justify-content-center">
          <div class="col-12 text-center">
            <div class="section-title mb-4 pb-2">
              <h4 class="title mb-4">Best Services For You</h4>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->

        <div class="mt-5">
          <Features :featuresData="featuresData" />
        </div>
        <!-- <div class="mt-5">
          <Features :featuresData="featuresData2" />
        </div> -->
      </div>
      <!--end container-->
    </section>
    <!--end section-->
    <div class="position-relative">
      <div class="shape overflow-hidden text-light">
        <svg
          viewBox="0 0 2880 250"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M720 125L2160 0H2880V250H0V125H720Z"
            fill="currentColor"
          ></path>
        </svg>
      </div>
    </div>
    <!-- End services -->

    <Footer id="contact" />
    <!-- Footer End -->
    <!-- Back to top -->
    <a
      href="javascript: void(0);"
      class="btn btn-icon btn-primary back-to-top"
      id="back-to-top"
      v-scroll-to="'#topnav'"
    >
      <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
    <!-- Back to top -->
  </div>
</template>

<style>
.modal-content {
  background-color: transparent;
}

::v-deep .carousel-caption {
  display: contents;
}

.carousel-caption {
  width: 100%;
  height: auto !important;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  margin: auto;
  position: unset !important;
}
</style>
